import { ethers } from 'ethers';

// EternalStorage tracks each writter contract under a named slot.
// The slot key is keccak256 of the human-readable label. We pin the
// computed values here to (1) document them in source, (2) let UI
// elements display the real bytes32 hash next to a slot row, and
// (3) act as a self-test in dev mode.

export const SLOT_NAMES = [
  'Token',
  'Token Management',
  'Auditing Pool',
  'Governance',
] as const;

export type SlotName = (typeof SLOT_NAMES)[number];

// Pinned at Phase 0 audit (2026-05-10) — recompute via slotHash() at boot.
export const SLOT_HASHES: Record<SlotName, `0x${string}`> = {
  'Token':            '0x1317f51c845ce3bfb7c268e5337a825f12f3d0af9584c2bbfbf4e64e314eaf73',
  'Token Management': '0xf211cd286baf73f1080b70167f1e337318ed8eb6a6a297dd53d1eb5ed41cfa42',
  'Auditing Pool':    '0x4855f03b3d03850cd0e1a6f2ad2d6f13be451750f929ff03199183eb1cbbb7e7',
  'Governance':       '0x9409903de1e6fd852dfc61c9dacb48196c48535b60e25abf92acc92dd689078d',
};

export function slotHash(name: SlotName): string {
  return ethers.keccak256(ethers.toUtf8Bytes(name));
}

// Dev-only sanity check — call at boot to verify the pinned values
// still match the runtime computation. Fails loud, not silently.
export function assertSlotsConsistent(): void {
  for (const name of SLOT_NAMES) {
    const live = slotHash(name);
    const pinned = SLOT_HASHES[name];
    if (live !== pinned) {
      // eslint-disable-next-line no-console
      console.error(`[slots] mismatch for "${name}": live=${live} pinned=${pinned}`);
    }
  }
}
